import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export enum RejectionReason {
    Network,
    Bug,
    Invalid,
    Conflict,
    Expired,
}

type AccountCreationStateInitializing = {
    kind: 'initializing',
    pending: boolean,
	rejectionReason?: RejectionReason,
}

type AccountCreationStateReady = {
    kind: 'ready',
    pending: boolean,
    rejectionReason?: RejectionReason,
    email: string,
}

type AccountCreationStateDone = {
    kind: 'done',
}

export type AccountCreationState
    = AccountCreationStateInitializing
    | AccountCreationStateReady
    | AccountCreationStateDone;

const initialState = {
    kind: 'initializing',
    pending: false,
} as AccountCreationState;

export const localeSlice = createSlice({
	name: 'accountCreation',
	initialState,
	reducers: {
		reset: (state, action: PayloadAction<RejectionReason | undefined>): AccountCreationState => ({
            kind: 'initializing',
            pending: false,
            rejectionReason: action.payload,
		}),
		loading: (state): AccountCreationState => ({
            kind: 'initializing',
            pending: true,
		}),
        ready: (state, action: PayloadAction<string>): AccountCreationState => ({
            kind: 'ready',
            pending: false,
            email: action.payload,
        }),
        submitting: (state): AccountCreationState => {
            if (state.kind !== 'ready') {
                throw new Error("must be in state ready");
            }
            return {
                kind: 'ready',
                pending: true,
                email: state.email,
            }
        },
        failure: (state, action: PayloadAction<RejectionReason>): AccountCreationState => {
            if (state.kind !== 'ready') {
                throw new Error("must be in state ready");
            }
            return {
                kind: 'ready',
                pending: false,
                rejectionReason: action.payload,
                email: state.email,
            }
        },
        done: (state): AccountCreationState => {
            if (state.kind !== 'ready') {
                throw new Error("must be in state ready");
            }
            return {
                kind: 'done',
            }
        }
	},
});

export function isInitial(state: AccountCreationState): boolean {
    return state.kind === 'initializing'
        && state.pending === false
        && state.rejectionReason === undefined;
}

export const { reset, loading, ready, submitting, failure, done } = localeSlice.actions;
export default localeSlice.reducer;

